import { takeLatest, call, put } from 'redux-saga/effects'
import { destroyMeetingBlock } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}

async function handleDestroyMeetingBlock(MeetingBlockId: number) {
  return destroyMeetingBlock(MeetingBlockId)
}

function* destroyMeetingBlockEffectSaga(action: any) {
  try {
    const {
      payload: { meetingBlockId, lessonId },
    } = action
    yield call(handleDestroyMeetingBlock, meetingBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyMeetingBlockWatcherSaga() {
  yield takeLatest(
    fromActions.DESTROY_MEETING_BLOCK,
    destroyMeetingBlockEffectSaga
  )
}
